import React from 'react';
import { Wrapper } from './ProfileScreen.styles';
import { NavLink, Outlet } from 'react-router-dom';
import { AppRoutes } from '../../../logic/core/routes';
import { useBaseScreenHook } from '../../../logic/core/base-screen.hook';

const ProfileScreen = () => {

    const {t} = useBaseScreenHook();

    return <Wrapper>
        <div className="profile-tabs">
            <NavLink className={`tab`} to={AppRoutes.profileData}>
                {t('profileScreen.profileData')}
            </NavLink>
            <NavLink className={`tab`} to={AppRoutes.profileSettings}>
                {t('profileScreen.profileSettings')}
            </NavLink>
        </div>

        <Outlet/>
    </Wrapper>
}

export default ProfileScreen;
